import { IRequest, ISignal } from 'types';

export type RequestListItem = IRequest | ISignal;
export type TenantHouseProviderPair = [houseId: string, providerId: string];

export const isRequestItem = (item: RequestListItem): item is IRequest =>
  item.item_type === 'request';

export const isSignalItem = (item: RequestListItem): item is ISignal =>
  item.item_type === 'signal';

export const getListItemNumber = (item: RequestListItem) => `${item.number}`;

export const collectConversationIds = (items: RequestListItem[]) =>
  items.reduce<string[]>((ids, item) => {
    if (isRequestItem(item) && item.conversation_id !== null) {
      ids.push(String(item.conversation_id));
    }

    return ids;
  }, []);

export const buildUniqueTenantsWithHouseMap = (items: RequestListItem[]) =>
  items.reduce<Record<string, TenantHouseProviderPair>>((result, item) => {
    if (
      isRequestItem(item) &&
      item.requester?._id &&
      item.requester._type === 'tenant' &&
      item.status === 'performed'
    ) {
      result[item.requester._id] = [item.house._id, item.provider._id];
    }

    return result;
  }, {});

export const findRequestById = (
  items: RequestListItem[],
  id: string
) => items.find((item): item is IRequest => isRequestItem(item) && item._id === id);
